import { Component, ElementRef, ViewChild } from '@angular/core';
import { ScrollDispatcher, ViewportRuler } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true
})
export class HeaderComponent {
  @ViewChild('navbarBrand', { static: true })
  navbarBrand!: ElementRef;

  @ViewChild('navbarTop', { static: true })
  navbarTop!: ElementRef;

  isMenuCollapsed = true;

  constructor(
    private readonly scrollDispatcher: ScrollDispatcher,
    private readonly viewportRuler: ViewportRuler) {
    this.scrollDispatcher.scrolled().subscribe(() => {
      let navbarBrandHeight = Number(this.navbarBrand.nativeElement.clientHeight)
      this.navbarTop.nativeElement.style.top = `${navbarBrandHeight - window.scrollY > 0 ? navbarBrandHeight - window.scrollY : 0}px`;
    });
    this.viewportRuler.change().subscribe(() => {
      let navbarBrandHeight = Number(this.navbarBrand.nativeElement.clientHeight)
      this.navbarTop.nativeElement.style.top = `${navbarBrandHeight - window.scrollY > 0 ? navbarBrandHeight - window.scrollY : 0}px`;
    });
  }
}
